import { Component } from 'react';
import InputWithChips from './InputWithChips';
import PropTypes from 'prop-types';

class IntegerInputWithChips extends Component {

    constructor(props) {
        super(props);

        this.state = {
            chips: this.generateChips(),
        }
    }

    generateChips() {
        let chips = [];

        for (let i = this.props.min; i <= this.props.max; i += this.props.step) {
            chips.push({ name: i, value: i })
        }

        return chips;
    }

    onClick(chip) {
        this.props.onClick(chip);
    }

    render() {
        return (
            <InputWithChips chips={this.state.chips} onClick={this.onClick.bind(this)} selectedValue={this.props.selectedValue}
                multipleSelection={this.props.multipleSelection} selectedValues={this.props.selectedValues} />
        )
    }
}

IntegerInputWithChips.propTypes = {
    onClick: PropTypes.func.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired,
    selectedChip: PropTypes.object,
    selectedChips: PropTypes.array,
    multipleSelection: PropTypes.bool,
}

export default (IntegerInputWithChips);
